import { render, staticRenderFns } from "./push.vue?vue&type=template&id=0b1c79fc&scoped=true&"
import script from "./push.vue?vue&type=script&lang=js&"
export * from "./push.vue?vue&type=script&lang=js&"
import style0 from "./push.css?vue&type=style&index=0&id=0b1c79fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1c79fc",
  null
  
)

export default component.exports